import { render, staticRenderFns } from "./distintaBase.vue?vue&type=template&id=56542bd9"
import script from "./distintaBase.vue?vue&type=script&lang=js"
export * from "./distintaBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports